// Puts saved payment methods in the given id order. Rows without an id (new,
// unsaved) and ids not in the list keep their place after the ordered ones.
export const applyPaymentMethodOrder = <T extends { id?: number }>(
  rows: T[],
  ids: number[]
): T[] => {
  const position = new Map(ids.map((id, index) => [id, index]));
  const rank = (row: T) =>
    row.id != null && position.has(row.id)
      ? (position.get(row.id) as number)
      : Number.MAX_SAFE_INTEGER;

  return rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) => rank(a.row) - rank(b.row) || a.index - b.index)
    .map(({ row }) => row);
};

export const movePaymentMethod = <T>(rows: T[], from: number, to: number) => {
  const next = [...rows];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
};
